import { get } from './apiClient';

/**
 * Fetch Admin Dashboard Statistics (KPIs)
 * @returns {Promise<Object>} Dashboard statistics
 */
export const fetchAdminDashboardStats = async (period = '30d') => {
    try {
        const response = await get(`/dashboard/admin-stats?period=${encodeURIComponent(period)}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
